import { render, staticRenderFns } from "./lrNewEditor.vue?vue&type=template&id=706a92e0&scoped=true&"
import script from "./lrNewEditor.vue?vue&type=script&lang=js&"
export * from "./lrNewEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a92e0",
  null
  
)

export default component.exports